module.exports = __webpack_public_path__ + "img/Yellow_back.5e304aed.jpg";